import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { SLEEP, ANXIETY, PAIN, AWAKENING } from '../../utils/constants'

import {
  ProgressBarU,
  ProgressBarL,
  ProgressBarJ,
} from './PlayerProgressBars/ProgressBarSvgs'

class PlayerProgressBar extends React.Component {
  constructor(props) {
    super(props)

    switch (this.props.indicationType) {
      case PAIN:
      case ANXIETY:
        this.ProgressBarSvg = ProgressBarU
        this.x2Min = 65
        this.x1 = 65
        this.x2 = 65
        this.y1 = 56
        this.y2 = 57
        this.xTotalDiff = 915

        this.quadraticY = (x) => -0.00282 * x ** 2 + 3.0757 * x - 129.99
        break
      case SLEEP:
        this.ProgressBarSvg = ProgressBarL
        this.x2Min = 68
        this.x1Min = 68
        this.x1 = 68
        this.x2 = 68
        this.y1 = -1
        this.y2 = 0
        this.xTotalDiff = 944
        this.quadraticY = (x) => -0.002043 * x ** 2 + 2.771 * x - 179
        break
      case AWAKENING:
        this.ProgressBarSvg = ProgressBarJ
        this.x2Min = 0
        this.x1 = -1
        this.x2 = 0
        this.y1 = 635
        this.y2 = 636
        this.xTotalDiff = 955
        this.quadraticY = (x) => -0.00157 * x ** 2 + 0.8333 * x + 636
        break
    }
  }

  x2LessThan = (x2, lessThan) =>
    x2 - 1 < lessThan
      ? 1
      : x2 - 1 < lessThan + 3
      ? 0.9
      : x2 - 1 < lessThan + 6
      ? 0.8
      : x2 - 1 < lessThan + 9
      ? 0.7
      : x2 - 1 < lessThan + 12
      ? 0.6
      : x2 - 1 < lessThan + 15
      ? 0.5
      : x2 - 1 < lessThan + 18
      ? 0.4
      : x2 - 1 < lessThan + 21
      ? 0.3
      : x2 - 1 < lessThan + 24
      ? 0.25
      : x2 - 1 < lessThan + 27
      ? 0.2
      : x2 - 1 < lessThan + 30
      ? 0.16
      : x2 - 1 < lessThan + 33
      ? 0.12
      : x2 - 1 < lessThan + 36
      ? 0.09
      : x2 - 1 < lessThan + 39
      ? 0.06
      : x2 - 1 < lessThan + 43
      ? 0.03
      : x2 - 1 < lessThan + 46
      ? 0.02
      : x2 - 1 < lessThan + 49
      ? 0.01
      : 0

  x2GreaterThan = (x2, greaterThan) =>
    x2 - 1 < greaterThan + 3
      ? 0
      : x2 - 1 < greaterThan + 4
      ? 0.02
      : x2 - 1 < greaterThan + 6
      ? 0.04
      : x2 - 1 < greaterThan + 9
      ? 0.06
      : x2 - 1 < greaterThan + 12
      ? 0.08
      : x2 - 1 < greaterThan + 15
      ? 0.1
      : x2 - 1 < greaterThan + 18
      ? 0.12
      : x2 - 1 < greaterThan + 21
      ? 0.15
      : x2 - 1 < greaterThan + 24
      ? 0.18
      : x2 - 1 < greaterThan + 27
      ? 0.2
      : x2 - 1 < greaterThan + 30
      ? 0.22
      : x2 - 1 < greaterThan + 32.5
      ? 0.24
      : x2 - 1 < greaterThan + 35
      ? 0.26
      : x2 - 1 < greaterThan + 37.5
      ? 0.29
      : x2 - 1 < greaterThan + 40
      ? 0.32
      : x2 - 1 < greaterThan + 42
      ? 0.36
      : x2 - 1 < greaterThan + 44
      ? 0.42
      : x2 - 1 < greaterThan + 46
      ? 0.47
      : x2 - 1 < greaterThan + 47
      ? 0.56
      : x2 - 1 < greaterThan + 48
      ? 0.66
      : 0.78

  componentDidMount() {
    const indicationType = this.props.indicationType
    const indicationTypeCode =
      indicationType === 'anxiety' || indicationType === 'pain'
        ? 'u'
        : indicationType === 'sleep'
        ? 'l'
        : indicationType === 'awakening'
        ? 'j'
        : ''

    if (!indicationTypeCode) throw Error('Invalid session type')

    const gradientEl = document.getElementById(`${indicationTypeCode}_progress_bar_lg`)

    gradientEl.setAttribute('x1', this.x1)
    gradientEl.setAttribute('x2', this.x2)
    gradientEl.setAttribute('y1', this.y1)
    gradientEl.setAttribute('y2', this.y2)
  }

  componentDidUpdate() {
    if (!this.props.totalTimeDuration) return

    const progressRatio = this.props.playTimeCurrent / this.props.totalTimeDuration

    const indicationType = this.props.indicationType
    const indicationTypeCode =
      indicationType === 'anxiety' || indicationType === 'pain'
        ? 'u'
        : indicationType === 'sleep'
        ? 'l'
        : indicationType === 'awakening'
        ? 'j'
        : ''

    if (!indicationTypeCode) return

    const gradientEl = document.getElementById(`${indicationTypeCode}_progress_bar_lg`)

    switch (this.props.indicationType) {
      case PAIN:
      case ANXIETY:
        this.x2 = this.xTotalDiff * progressRatio + this.x2Min
        this.y2 = this.quadraticY(this.x2)
        this.x1 = this.x2 - 1 < 120 || this.x2 - 1 > 969 ? this.x2 : this.x2 - 0.1
        this.y1 =
          this.x2 - 1 < 120
            ? this.y2 - 1
            : this.x2 - 1 > 969
            ? this.y2 + 1
            : this.x2 - 1 > 920
            ? this.quadraticY(this.x1 - this.x2GreaterThan(this.x2, 920))
            : this.quadraticY(this.x1 - this.x2LessThan(this.x2, 140))

        if (!this.switchedSides && this.x2 > 500) {
          this.switchedSides = true
          const leftCover = document.getElementById('u_left_cover')
          const rightCover = document.getElementById('u_right_cover')
          leftCover.style.display = 'initial'
          rightCover.style.display = 'none'
        }
        break
      case SLEEP:
        this.x2 = this.xTotalDiff * progressRatio + this.x2Min
        this.y2 = this.quadraticY(this.x2)
        this.x1 = this.x2 - 1 < 120 ? this.x2 : this.x2 - 0.1
        this.y1 =
          this.x2 - 1 < 120
            ? this.y2 - 1
            : this.quadraticY(this.x1 - this.x2LessThan(this.x2, 140))
        break
      case AWAKENING:
        this.x2 = this.xTotalDiff * progressRatio + this.x2Min
        this.y2 = this.quadraticY(this.x2)
        this.x1 = this.x2 - 1 > 936 ? this.x2 : this.x2 - 0.1
        this.y1 =
          this.x2 - 1 > 936
            ? this.y2 + 1
            : this.x2 - 1 > 887
            ? this.quadraticY(this.x1 - this.x2GreaterThan(this.x2, 887))
            : this.quadraticY(this.x1)
        break
    }

    gradientEl.setAttribute('x1', this.x1)
    gradientEl.setAttribute('x2', this.x2)
    gradientEl.setAttribute('y1', this.y1)
    gradientEl.setAttribute('y2', this.y2)
  }

  render() {
    const ProgressBarSvg = this.ProgressBarSvg

    return (
      <div className="player_progress_bar_wrap">
        <ProgressBarSvg className="player_progress_bar" />
      </div>
    )
  }
}

const mapStateToProps = ({ player: { indicationType } }) => ({
  indicationType,
})

export default connect(mapStateToProps)(PlayerProgressBar)

PlayerProgressBar.propTypes = {
  playTimeCurrent: PropTypes.number,
  indicationType: PropTypes.oneOf([SLEEP, ANXIETY, PAIN, AWAKENING]),
  totalTimeDuration: PropTypes.number,
}
